/**
 * useCartShipments
 * The custom hook which provided to external use via context
 */

import { useContext } from 'react'

import CartShipmentsContext from './cart-shipments-context'

const useCartShipments = () => {
  const context = useContext(CartShipmentsContext)
  return context
}

export default useCartShipments
